module.exports = __webpack_public_path__ + "img/4.bde17868.png";